<template>
  <section id="ranges">
    <Styles>
      <div class="ranges-form">
        <div class="columns">
          <div class="column header">
            <h4 class="form-title">Agregar rango</h4>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Valor inicial">
              <b-input
                placeholder="Ingrese el Valor inical"
                type="text"
                name="initRange"
                v-model="initRange"
                v-validate="'required|numeric|min_value:0'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("initRange") }}</span>
          </div>
          <div class="column">
            <b-field label="Valor final">
              <b-input
                placeholder="Ingrese el Valor final"
                type="text"
                name="finalRange"
                v-model="finalRange"
                v-validate="'required|numeric|min_value:0'"
              />
            </b-field>
            <span class="show-error">{{ errors.first("finalRange") }}</span>
          </div>
          <div class="column">
            <b-field label="Descuento">
              <b-select
                placeholder="Seleccione el descuento"
                expanded
                v-model="discount"
                name="discount"
              >
                <option
                  v-for="option in discountsList"
                  :value="option.code"
                  :key="option.code"
                  :id="option.code"
                >
                  {{ option.title }}
                </option>
                <option
                  v-if="
                    Array.isArray(discountsList) && discountsList.length == 0
                  "
                >
                  Aún No has creado descuentos para esta empresa
                </option>
              </b-select>
            </b-field>
            <span class="show-error">{{ errors.first("discount") }}</span>
          </div>
          <div class="column mt-button">
            <vs-button
              color="primary"
              title="Agregar"
              type="filled"
              icon="check"
              @click="addRange"
            >
            </vs-button>
            <vs-button
              color="danger"
              title="Cancelar"
              type="filled"
              icon="close"
            >
            </vs-button>
          </div>
        </div>
      </div>
      <div class="ranges-discount-content" v-if="mask">
        <b-table
          :data="getRanges()"
          class="table-ranges"
          v-if="Array.isArray(ranges) && ranges.length > 0"
        >
          <b-table-column
            field="initRange"
            label="Valor inicial"
            v-slot="props"
          >
            {{ props.row.initRange }}
          </b-table-column>
          <b-table-column field="finalRange" label="Valor final" v-slot="props">
            {{ props.row.finalRange }}
          </b-table-column>
          <b-table-column field="discount" label="Descuento" v-slot="props">
            {{ props.row.discount.title }}
          </b-table-column>
          <b-table-column field="value" label="Valor" v-slot="props">
            {{ getValue(props.row.discount) }}
          </b-table-column>
          <b-table-column field="value" label="Valor" v-slot="props">
            <vs-button
              icon="edit"
              color="primary"
              type="filled"
              @click="edit(props.row)"
            >
            </vs-button>
            <vs-button
              icon="close"
              color="danger"
              type="filled"
              @click="remove(props.row)"
            >
            </vs-button>
          </b-table-column>
        </b-table>
      </div>
    </Styles>
  </section>
</template>

<script>
import Styles from "./styles";
import { formatPrice, confirmation } from "../../../global/utils";
export default {
  name: "Ranges",
  props: {
    ranges: {
      type: Array,
      default: [],
    },
    mask: {
      default: Object,
      default: null,
    },
    discountTypes: {
      type: Array,
      default: [],
    },
    discountsList: {
      type: Array,
      default: [],
    },
  },
  components: { Styles },
  data: () => ({
    initRange: null,
    finalRange: null,
    discountType: null,
    discount: null,
    editing: false,
    actualIndex: null,
  }),
  watch: {},
  mounted() {},
  methods: {
    getRanges() {
      return this.ranges.filter((item) => !item.delete);
    },
    edit(row) {
      console.log("EDIT RANGE: ", row);
      this.editing = true;
      this.initRange = row.initRange;
      this.finalRange = row.finalRange;
      this.discount = row.discount.code;
      this.actualIndex = row.index;
    },
    remove(row) {
      confirmation(this, "¿Desea eliminar realmente el registro?").then(
        (result) => {
          console.log(result);
          this.$emit("updateRangeList", { ...row, delete: true });
        }
      );
    },
    getValue(item) {
      switch (item.classification) {
        case "P":
          return `${item.amount}%`;
        case "T":
        case "M":
          return `${item.amount} Minutos`;
        case "C":
          return `${formatPrice(item.amount)}`;
      }
    },
    getDiscountTypeName(discountCode) {
      console.log("DCode", discountCode);
      console.log("DTypes", this.discountTypes);
      const discount = this.discountTypes.find(
        (item) => item.id == discountCode
      );
      if (!discount) {
        return "No definido";
      }
      return discount.name;
    },
    getDiscountByCode(code) {
      return this.discountsList.find((item) => item.code === code);
    },
    addRange() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        const item = {
          initRange: this.initRange,
          finalRange: this.finalRange,
          discount: this.getDiscountByCode(this.discount),
          discountType: this.discountType,
          index: this.editing ? this.actualIndex : this.ranges.length,
        };
        this.$emit("updateRangeList", item);
        this.initRange = null;
        this.finalRange = null;
        this.discountType = null;
        this.discount = null;
        this.value = null;
        this.addActived = false;
        this.actualIndex = null;
        this.editing = false;
        this.$validator.reset();
      });
    },
  },
};
</script>
